import ms from 'ms';

export const PER_PAGE = 25;
export const SEARCH_DEBOUNCE_TIME = 300;
export const QUERY_STALE_TIME = ms('5m');
